module.exports = __webpack_public_path__ + "superman.jpg?12e7a39416b28a46a52a22eaca4245d9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/superman.jpg
// module id = 160
// module chunks = 0